const initialState = () => ({
  page: 1,
  lead_status: "Pending",
  dealer_id: [], // multi-select
  company_name: "",
  // Borrower Company: the borrower's employer, typed free-hand. On the Signup
  // section it reads the company typed at sign-up.
  employer_name: "",
  executive_type: null,
  executive_name: [], // multi-select
  product_type: [], // multi-select
  loan_type: "",
  // Payable (staff only): "true" -> leads whose latest dealer loan the partner
  // is paid for, "false" -> the rest, "" -> no filtering. See app-js/payable-filter.js.
  payable_loan_flag: "",
  // multi-select; only shown (and only meaningful) on the Rejected tab
  rejection_category: [],
  // Where the lead came from — multi-select over BorrowerBasicInformation.lead_platform
  // (WEB / IOS / ANDROID / STAFF / UNKNOWN). Sits with the other lead-only filters.
  lead_platform: [], // multi-select
  source1: "",
  source2: "",
  signup_display_daterange: "",
  signup_date_range: [],
  initiated_display_daterange: "",
  initiated_date_range: [],
  // Backlog Days range: whole days since the lead's LOS application was
  // created. Strings, as the number inputs emit them; either may be blank.
  backlog_days_min: "",
  backlog_days_max: "",
  // Active tab / sub-tab view state, persisted so returning to the leads page
  // restores the same tab (and its filters) instead of resetting to default.
  // A fresh store lands on the "Pending" main tab with its sub-tabs collapsed.
  // There is no selected_tab index here: "Signup" is only prepended for
  // non-Dealer roles, so Pending's index differs per role — AgentList derives
  // the highlighted index from this state instead (activeTabIndex).
  isSubTabActive: false,
  currentSubStatus: null,
  showSubTabs: false,
  // Pre-lead signup funnel tab state. When active the list is served by the
  // signup-stage endpoint instead of the dealer-lead endpoints; mutually
  // exclusive with isSubTabActive.
  isSignupStageActive: false,
  currentSignupStage: null,
  // Whether the "Signup" section tab is expanded to show its stage sub-tabs
  // (same pattern as showSubTabs for Pending).
  showSignupSubTabs: false,
});

export default {
    namespaced: true,
    state: initialState(),
  
    mutations: {
      RESET_FILTERS(state) {
        Object.assign(state, initialState());
      },
    },
    actions: {
      resetFilters({ commit }) {
        commit("RESET_FILTERS");
      },
    },
    getters: {
      getInitialFilters: () => initialState(),
      getFilters: (state) => {
        return state;
      },
    },
  };
